import { editAgent } from "../roles";
import marker from "../../assets/img/marker.png"
import moment from "moment";
import { Link } from "react-router-dom";
export const agentColumns = (
  roles,
  showLocationModal,
  storeAgentId,
  storeRow,
  showEditModal
) => {
  const columns = [
    {
      name: "Id",
      cell: (row) => row["id"],
    },
    {
      name: "Names",
      cell: (row) => (
        <div>{`${row?.subscriber?.firstName} ${row?.subscriber?.lastName}`}</div>
      ),
    },
    {
      name: "Phone number",
      cell: (row) => row?.subscriber?.phoneNumber,
    },
    {
      name: "Type",
      cell: (row) => row["type"]?.name,
    },
    {
      name: "Commission Rate",
      cell: (row) => row["commissionRate"],
    },
    {
      name: "Status",
      cell: (row) => row["status"]?.name,
    },
    {
      name: "Created On",
      cell: (row) => moment(row["createdAt"]).format("DD-MM-YYYY"),
    },
    {
      name: <div className='d-flex justify-content-end'>Actions</div>,
      cell: (row) => (
        <div className='d-flex' style={{ gap: 20 }}>
          <Link to={`/loggedin/admin/agents/${row.id}`}>
            <i
              className='fa fa-eye'
              aria-hidden='true'
              style={{
                cursor: "pointer",
                color: "#124db1",
                fontWeight: 700,
              }}
            />
          </Link>
          {roles?.some((role) => role.id === editAgent) && (
            <>
              <i
                className='fa fa-pen'
                style={{ color: "#124db1", cursor: "pointer" }}
                onClick={() => {
                  storeRow(row);
                  showEditModal("update");
                }}
              />
              <img
                src={marker}
                width={25}
                height={30}
                alt='location icon'
                style={{ cursor: "pointer" }}
                title='Add location to this agent'
                onClick={() => {
                  showLocationModal(true);
                  storeAgentId(row["id"]);
                }}
              />
            </>
          )}
        </div>
      ),
    },
  ];
  return columns;
};